import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var successIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "11",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.837 17.6a.623.623 0 0 1-.4-.153L6 14.393l.264-.298a.8.8 0 0 1 1.138-.073l2.403 2.112 6.761-7.857a.798.798 0 0 1 1.13-.08l.304.266-7.666 8.928a.591.591 0 0 1-.417.2l-.08.009z",
  fill: "currentColor",
  fillRule: "nonzero"
})));

export { successIcon as default };
//# sourceMappingURL=successIcon.js.map
